import { createContext, ReactNode, useContext } from "react";
import { components } from "@convergence/client";
import { useMeQuery } from "../api/me";
import { fetch } from "../fetch";

export const AuthContext = createContext(
    {} as {
        user?: components["schemas"]["MeResponse"]["user"];
        isLoading?: boolean;
        error?: Error | null;
    }
);

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = (props: { children: ReactNode }) => {
    const { isLoading, data, error } = useMeQuery(fetch);
    console.log(data);
    return (
        <AuthContext.Provider value={{ user: data?.user, isLoading, error }}>
            {props.children}
        </AuthContext.Provider>
    );
};
